import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

// DON NOT REMOVE the comments around 'import style.scss'
// ###STYLE_REPLACEMENT_START###
import './style.scss'
// ###STYLE_REPLACEMENT_END###

const Chips = ({ value, onClick, kind, borderRadiusStyle, extraClasses, ...restProps }) => {
  return (
    <label
      className={classnames(`gdpp-component fil-chips fil-chips--${kind} fil-chips--border-${borderRadiusStyle}`, extraClasses)}
      {...restProps}
    >
      <span>{value}</span>
      <span>
        <fil-icon icon="close" size="12" onClick={onClick} />
      </span>
    </label>
  )
}

Chips.propTypes = {
  value: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  extraClasses: PropTypes.string,
  kind: PropTypes.string,
  borderRadiusStyle: PropTypes.string
}

Chips.defaultProps = {
  extraClasses: '',
  kind: 'primary',
  borderRadiusStyle: 'default'
}

export default Chips
